import React from 'react';
import moment from 'moment';

import { USAGE_DATE_FORMAT } from '../../constants';

const DailyUsageList = ({ usage = [] }) => (
  <div>
    <table className="table">
      <thead>
        <tr>
          <th className="text-center">MB 3G</th>
          <th className="text-center">MB LTS</th>
          <th className="text-center">MB Used</th>
          <th className="text-center">MMS</th>
          <th className="text-center">Since</th>
          <th className="text-center">Until</th>
        </tr>
      </thead>
      <tbody>
        {usage.length > 0 &&
          usage.map((record, index) => (
            <tr key={index}>
              <td className="text-center">{record.mb_3g}</td>
              <td className="text-center">{record.mb_lte}</td>
              <td className="text-center">{record.mb_used}</td>
              <td className="text-center">{record.mms}</td>
              <td className="text-center">
                {moment(record.since_ts).format(USAGE_DATE_FORMAT)}
              </td>
              <td className="text-center">
                {moment(record.until_ts).format(USAGE_DATE_FORMAT)}
              </td>
            </tr>
          ))}
        {usage.length === 0 ? (
          <tr>
            <td colSpan="6">No records yet</td>
          </tr>
        ) : null}
      </tbody>
    </table>
  </div>
);

export default DailyUsageList;
